import type { OwnerScheduleData } from '@court-sync/shared';
import { apiGet } from './apiClient';

export type {
  OwnerScheduleData,
  OwnerSchedulePendingBooking,
  ReportedAbsenceSessionRef,
} from '@court-sync/shared';

export const ownerScheduleService = {
  async getOwnerSchedule(
    academyId: string,
    startDateYmd: string,
    endDateYmd: string,
    options?: { bypassCache?: boolean },
  ): Promise<OwnerScheduleData | null> {
    const response = await apiGet<OwnerScheduleData>(
      `/academies/${academyId}/owner-schedule`,
      {
        params: {
          startDate: startDateYmd,
          endDate: endDateYmd,
          ...(options?.bypassCache ? { _: Date.now() } : {}),
        },
      },
    );
    if (!response.success || !response.data) return null;
    return response.data;
  },
};
